import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from '../market';

const VK_FAQ = [
  {
    title: 'Что такое Boostclick и как работает продвижение ВКонтакте*?',
    isH3: false,
    text:
      <p>
        Boostclick — это платформа, где заказчики размещают задачи, а исполнители выполняют их за вознаграждение.
        <br />
        Вы создаете проект с указанием ссылки на свою страницу, выбираете параметры и оплачиваете размещение. Дальше подключаются пользователи, которые выполняют задания: подписка, лайк, просмотр и т. п.
      </p>
  },
  {
    title: 'Чем это отличается от «накрутки» ботами?',
    isH3: false,
    text:
      <p>
        Boostclick не использует автоматические или программные методы. Все действия выполняют реальные пользователи вручную. Это снижает риски и повышает ценность аудитории.
      </p>
  },
  {
    title: 'Есть ли гарантии?',
    isH3: false,
    text:
      <p>
        Вы можете оценить каждый выполненный отчет в течение 72 часов.
        <br />
        Если что-то не устраивает — задание можно отклонить и назначить нового исполнителя. Boostclick обеспечивает прозрачную модерацию и отчетность.
      </p>
  },
  {
    title: 'Насколько это безопасно?',
    isH3: false,
    text:
      <p>
        Мы не гарантируем продвижения в поиске или прироста продаж, но соблюдаем все принципы ручного взаимодействия.
        <br />
        Boostclick не вмешивается в алгоритмы платформы и не обещает продвижение в результатах поиска.
      </p>
  },
  {
    title: 'Как создать проект?',
    isH3: false,
    text:
      <div>
        <ul>
          <li>Укажите ссылку на страницу или группу ВКонтакте*.</li>
          <li>Задайте желаемое количество подписчиков и дополнительных действий.</li>
          <li>Оплатите размещение.</li>
          <li>Отслеживайте выполнение и принимайте работы.</li>
        </ul>
      </div>
  },
  {
    title: 'Как повысить эффективность?',
    isH3: false,
    text:
      <div>
        <ul>
          <li>Создавайте интересный контент</li>
          <li>Приветствуйте новых подписчиков</li>
          <li>Публикуйте регулярно</li>
          <li>Работайте с комментариями и вовлеченностью</li>
        </ul>
      </div>
  },
];

const STEP_TWO_TITLE_FAQ = <p>
  Почему при добавлении одного действия в калькуляторе появляются дополнительные действия?
  <br />
  <br />
  Сервис формирует уникальные сценарии для каждого исполнителя, и каждый сценарий начинается для нового исполнителя с перехода на страницу по переданной вами ссылке.
</p>;

const CHAIN_PRICE = 4;
const CHAIN_STEPS = 4;

const ACTIONS = [
  {
    type: 'MAIN.SUBSCRIBE',
    icon: "people",
    iconHome: "home-people",
    title: 'Активная подписка (человек)',
    titleComment: '+ просмотр постов + просмотр профиля + отчет о работе',
    initialShare: 0.6,
    price: 1,
    activityType: 'Подписка',
  },
  {
    type: 'MAIN.LIKE',
    icon: "like",
    iconHome: "home-like",
    title: 'Поставить лайк / реакцию на пост',
    titleComment: '+ просмотр постов + просмотр профиля + отчет о работе',
    initialShare: 0.2,
    price: 1,
    activityType: 'Лайк',
  },
  {
    type: 'MAIN.WALL',
    icon: "repost",
    iconHome: "home-repost",
    title: 'Сделать репост на стену',
    initialShare: 0.1,
    price: 1,
    activityType: 'Стена',
  },
  {
    type: 'MAIN.REPOST',
    icon: "repost",
    iconHome: "home-repost",
    title: 'Переслать запись в сообщения',
    initialShare: 0.1,
    price: 1,
    activityType: 'Репост',
  },

  { type: 'ALWAYS.OPEN', icon: "open", iconHome: "home-open", title: 'Открыть ВКонтакте', initialShare: 1 },

  {
    type: 'ALWAYS.SEARCH',
    icon: "search",
    iconHome: "home-search",
    title: 'Найти страницу / группу',
    titleComment: 'должны быть открытые',
    initialShare: 1,
  },

  { type: 'EXTRA.SEE', icon: "glasses", iconHome: "home-glasses", title: 'Посмотреть последние 7 постов', initialShare: 0.7 },
  { type: 'EXTRA.PROFILE', icon: "glasses", iconHome: "home-glasses", title: 'Посмотреть профиль', initialShare: 0.3 },
  { type: 'EXTRA.MEDIA', icon: "eye", iconHome: "home-glasses", title: 'Посмотреть последний клип', titleComment: 'не дольше 1 мин', initialShare: 0 },

  {
    type: 'MAIN.SURVEY',
    icon: "survey",
    iconHome: '',
    title: 'Поучаствовать в опросе',
    titleComment: 'должен быть активным',
    initialShare: 0,
    activityType: 'Опрос',
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    path: "/nakrutka-podpischikov-vk",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.HIT,
  },
  {
    iconHome: "home-subscribe",
    title: "Подписка + просмотры",
    path: "/nakrutka-podpischikov-vk",
    target: '_self',
  },
  {
    iconHome: "home-like",
    title: "Лайк + просмотры",
    path: "/nakrutka-podpischikov-vk",
    target: '_self',
  },
  {
    iconHome: "home-repost",
    title: "Репост на стену",
    path: "/nakrutka-podpischikov-vk",
    target: '_self',
  },
  {
    iconHome: "home-repost-in-message",
    title: "Переслать в сообщения",
    path: "/nakrutka-podpischikov-vk",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Открыть VK*",
    path: "/nakrutka-podpischikov-vk",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти страницу / группу",
    path: "/nakrutka-podpischikov-vk",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Посмотреть последние 7 постов",
    path: "/nakrutka-podpischikov-vk",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Посмотреть профиль",
    path: "/nakrutka-podpischikov-vk",
    target: '_self',
  }
];

const VK_KEYWORDS = [
  'VK', 'vk', 'ВК', 'вк', 'Вконтакте', 'вконтакте'
];

class VkClass extends Market {

  id = 'vk';
  host = 'vk.com';
  hostsList = ['vk.com', 'vk.ru', 'vk.me', 'vk.cc', 'vkontakte.ru'];
  url = 'https://vk.com/';

  title = 'VK*';

  isMarketplace = false;

  icon = "vk";
  titlePlaces = 'VK*';
  statusForHomePage = MARKET_MODE_STATUS.POPULAR;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [];

  chainsPerDayNormal = 400 / 30;

  chainsMin = 10;
  chainsMax = 500;

  chainsDefault = 40;


  chainsStep = 10;
  viewsStep = 1;

  keywords = VK_KEYWORDS;

  targetLinkComment = <span>Укажите тут адрес вашей <b>открытой</b> страницы или группы во ВКонтакте</span>;
  targetLinkCommentShort = <span>Укажите ссылку на <b>открытую</b> страницу</span>;

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      marketKey: 'vk:chains',
      title: 'ПФ',
      navigateTitle: 'Активность: подписки, лайки, вовлеченность',
      path: '/nakrutka-podpischikov-vk',
      rating: 0.10,
      icon: "people",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.REGULAR,
      meta: {
        title: `Подписчики во ВКонтакте от ${CHAIN_PRICE / CHAIN_STEPS} руб. — заказать накрутку ЛЮДИ`,
        description: 'Подписчики ЛЮДИ во ВКонтакте — накрутка через Boostclick.',
        canonical: '/nakrutka-podpischikov-vk',
      },
      intro: {
        title: 'Продвижение ВКонтакте* подписчиками',
        comment: 'Через микрозадачи и участие реальных пользователей',
        points: [
          'Без ботов',
          'Только уникальные пользователи',
          'Только реальные подписчики',
          'Подробные отчеты',
          'Участие по прямой ссылке на вашу страницу или группу',
        ]
      },
      howItWorks: [
        'Распределите активности',
        'Укажите ссылку на страницу или группу',
        'Сервис создаст задания для исполнителей',
        'Исполнители выполнят задания и пришлют отчеты',
        'Проверьте отчеты, если все верно примите их, если есть ошибки, то смените исполнителя',
      ],
      stepPhrase1: 'Настройте параметры проекта привлечения подписчиков ВКонтакте*',
      stepPhrase2: 'Укажите информацию для поиска страницы или группы',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Привлечение подписчиков во ВКонтакте*',
      titleFAQ: "Вопрос-ответ: как накрутить живых подписчиков в ВК",
      faq: VK_FAQ,
      actions: ACTIONS,
      notice: [
        '* Сервис создает индивидуальные задания для пользователей, которые переходят по ссылке на вашу страницу или группу ВКонтакте*',
        'У каждого исполнителя — уникальный сценарий взаимодействия: просмотр, лайк, подписка.',
        'Такие действия имитируют живой интерес и обеспечивают разный пользовательский путь.',
        'Скорость и сложность зависят от объема заданий и выбранных условий.',
      ]
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на страницу или группу';
  invalidUrlStr = 'Укажите корректную ссылку на страницу или группу';
}

const Vk = new VkClass();
export default Vk;
